import './DashboardFormListComponent.scss';
import LinkComponent from "../../../shared/components/link/LinkComponent";
import {CommonService} from "../../../shared/services";
import moment from "moment-timezone";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import TableWrapperComponent from "../../../shared/components/table-wrapper/TableWrapperComponent";
import {APIConfig} from "../../../constants";
import {ITableColumn} from "../../../shared/models/table.model";
import SelectDropdownComponent from "../../../shared/components/form-controls/select-dropdown/SelectDropdownComponent";
import {useCallback, useEffect, useState} from "react";
import ButtonComponent from "../../../shared/components/button/ButtonComponent";
import {useNavigate} from "react-router-dom";
import ToolTipComponent from "../../../shared/components/tool-tip/ToolTipComponent";

interface DashboardFormListComponentProps {

}


const DashboardFormListComponent = (props: DashboardFormListComponentProps) => {

    const [casesData, setCasesData] = useState([]);
    const [caseDetailFilterData, setCaseDetailFilterData] = useState<any>({
        record_id: 'all',
    });
    const navigate = useNavigate();

    const handleNavigation = useCallback((type: string, id?: string, appointmentId?: string) => {
        if (type === 'waiver_form' && id) {
            navigate(CommonService._routeConfig.ClientWaiverAndReleaseRoute(id) + '?mode=renew')
        } else if (type === 'disclose_form' && id && appointmentId) {
            navigate(CommonService._routeConfig.ClientDisclosureRoute(id, appointmentId) + '?mode=renew');
        } else if (id) {
            navigate(CommonService._routeConfig.EditClientHealthReleaseRoute(id) + '?mode=renew');
        }
    }, [navigate]);

    const columns: ITableColumn[] = [
        {
            title: 'Title',
            dataIndex: 'title',
            key: 'title',
            render: (record: any) => {
                const tooltipText =
                    record.record_type === "performance_record"
                        ? `${CommonService.getDateFromTimezone(record?.case_details?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')} - ${record?.case_details?.program_focus}`
                        : record.record_type === "medical_record" && record?.case_details?.injury_details?.length
                            ? `${CommonService.getDateFromTimezone(record?.case_details?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')} - ${record?.case_details?.injury_details
                                .map((injury: any) => `${injury.body_part_name} (${injury.body_side})`)
                                .join(", ")}`
                            : "";
                return (<>
                        <ToolTipComponent showArrow={true} position={'right'}
                                          tooltip={<div>Case Name: {tooltipText || 'N/A'}</div>}>
                            <div> {record.title || 'N/A'}</div>
                        </ToolTipComponent>
                    </>
                )
            }
        },
        {
            title: 'Date of Document',
            dataIndex: 'date',
            key: 'date',
            align: 'center',
            render: (record: any) => {
                return (
                    <div>
                        {CommonService.getDateFromTimezone(record?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')}
                    </div>
                )
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: 'center',
            render: (record: any) => {
                return (<>
                    {record?.show_renew ?
                        <ButtonComponent color={'error'} size={'small'}
                                         onClick={() => handleNavigation(record?.type, record?._id, record?.appointment_id)}
                                         variant={'outlined'}>Renew</ButtonComponent> :
                        <ChipComponent label={record.is_active ? 'Active' : 'Inactive'}
                                       className={record.is_active ? 'active' : 'inactive'}/>}
                </>)
            }
        },
        {
            title: 'Action',
            key: 'action',
            dataIndex: 'action',
            align: 'center',
            fixed: 'right',
            render: (record: any) => {
                let route = '';
                if (record?.type === 'waiver_form') {
                    route = CommonService._routeConfig.ClientWaiverAndReleaseRoute(record?._id)
                } else if (record?.type === 'disclose_form') {
                    route = CommonService._routeConfig.ClientDisclosureRoute(record?._id, record?.appointment_id) + '?mode=edit'
                } else if (record?.type === 'release_form') {
                    route = CommonService._routeConfig.EditClientHealthReleaseRoute(record?._id) + '?mode=edit'
                }
                return (<div className={'d-flex justify-content-between align-items-center'}>
                    {/*doing this because react does not support disabled functionality for link*/}
                    {
                        !record?.show_edit && <div className={'disabled-edit edit'}>Edit</div>
                    }
                    {record?.show_edit && <>
                        <LinkComponent route={route} className={'mrg-right-15'}
                                       disabled={!record?.show_edit}>Edit</LinkComponent>
                    </>
                    }
                    <LinkComponent className={'disabled-edit mrg-left-10'} disabled={true}>View/Download</LinkComponent>

                </div>)

            }
        }
    ];

    const getCasesListLite = useCallback(() => {
        CommonService._cases.GetCasesListLite()
            .then((response) => {
                setCasesData(response.data);
            })
            .catch((error: any) => {
                setCasesData([]);
            })

    }, []);

    useEffect(() => {
        getCasesListLite();
    }, [getCasesListLite]);

    return (
        <div className="dashboard-form-list">
            <div className={'title-filter-wrapper ts-row'}>
                <div className={'name-wrapper'}> Case Selection:</div>
                <div className={'filter-wrapper'}>
                    <SelectDropdownComponent
                        isClearable={false}
                        options={[
                            {
                                _id: "all",
                                record_type: "all",
                                label: "All"
                            },
                            ...casesData
                        ]}
                        value={caseDetailFilterData?.record_id}
                        onUpdate={(value: any) => {
                            setCaseDetailFilterData({
                                ...caseDetailFilterData,
                                record_id: value
                            });
                        }}
                        valueExtractor={(option: any) => option._id}
                        displayWith={(option: any) => {
                            if (option?.record_type === "performance_record") {
                                return `${CommonService.getDateFromTimezone(option?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')} - ${option?.program_focus}`;
                            }

                            if (option?.record_type === "medical_record" && option?.injury_details?.length) {
                                const injuries = option.injury_details
                                    .map((injury: any) => `${injury.body_part_name} (${injury?.body_side})`)
                                    .join(", ");
                                return `${CommonService.getDateFromTimezone(option?.created_at, moment.tz.guess(), 'DD-MMM-YYYY')} - ${injuries}`;
                            }
                        }}
                    />

                </div>
            </div>
            <TableWrapperComponent url={APIConfig.DASHBOARD_FORM_LIST.URL}
                                   noDataText={'No forms have been added.'}
                                   extraPayload={caseDetailFilterData}
                                   method={APIConfig.DASHBOARD_FORM_LIST.METHOD}
                                   columns={columns}/>

        </div>
    );
}

export default DashboardFormListComponent;
